import {
    ChangeDetectionStrategy,
    Component,
    computed,
    ElementRef,
    inject,
    Signal,
    ViewEncapsulation,
} from '@angular/core';
import { FiQuizEditorStoreService } from '../fi-quiz-editor-store.service';
import { FiComponentsContainer } from '@fi-shared/fi-components-container';
import { IQuizEditItem, IQuizNotification } from '../../fi-quiz.d';
import { IQuizTimerSettings } from './timer-settings/quiz-timer-settings.component';
import { IQuizSharingSettings } from './sharing-settings/quiz-sharing-settings.component';

@Component({
    selector: 'fi-quiz-settings-tab',
    templateUrl: './quiz-settings-tab.component.html',
    styleUrl: './quiz-settings-tab.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-quiz-settings-tab' },
    standalone: false,
    providers: [{ provide: FiComponentsContainer, useExisting: FiQuizSettingsTabComponent }],
})
export class FiQuizSettingsTabComponent extends FiComponentsContainer {
    private fiQuizEditorStoreService = inject(FiQuizEditorStoreService);
    private elementRef = inject(ElementRef);

    protected quiz: Signal<IQuizEditItem> = this.fiQuizEditorStoreService.currentQuizData;
    protected timerSettings = computed(() => {
        return {
            IsTimerEnabled: this.quiz()?.IsTimerEnabled,
            TimerMs: this.quiz()?.TimerMs,
        };
    });
    protected sharingSettings = computed(() => {
        return {
            AccessRightFilterCollection: this.quiz()?.AccessRightFilterCollection,
            IsShared: this.quiz()?.IsShared,
        };
    });
    protected scrollableElementRefs: ElementRef<HTMLElement>[] = [this.elementRef];

    protected onPassThresholdChanged(newPassThreshold: number): void {
        this.fiQuizEditorStoreService.updateCurrentQuizData((current) => ({
            ...current,
            PassThreshold: newPassThreshold,
        }));
    }

    protected onAllowRetakesChanged(newAllowRetakes: boolean): void {
        this.fiQuizEditorStoreService.updateCurrentQuizData((current) => ({
            ...current,
            AllowRetakes: newAllowRetakes,
        }));
    }

    protected onNotificationsChanged(newNotifications: IQuizNotification[]): void {
        this.fiQuizEditorStoreService.updateCurrentQuizData((current) => ({
            ...current,
            Notifications: newNotifications,
        }));
    }

    protected onTimerSettingsChanged(newTimerSettings: IQuizTimerSettings): void {
        this.fiQuizEditorStoreService.updateCurrentQuizData((current) => ({
            ...current,
            IsTimerEnabled: newTimerSettings.IsTimerEnabled,
            TimerMs: newTimerSettings.TimerMs,
        }));
    }

    protected onSharingSettingsChanged(newSharingSettings: IQuizSharingSettings): void {
        this.fiQuizEditorStoreService.updateCurrentQuizData((current) => ({
            ...current,
            AccessRightFilterCollection: newSharingSettings.AccessRightFilterCollection,
            IsShared: newSharingSettings.IsShared,
        }));
    }
}
